import apiFetch from "../../../shared/services/apiClient";

const BASE = "/api/agua/lecturas";

async function leerJson(res, mensajeError) {
  if (!res.ok) {
    const d = await res.json().catch(() => null);
    // Un 500 devuelve HTML, no JSON: sin este caso el usuario veía "{}" como
    // mensaje de error y no había forma de saber qué pasó.
    let texto;
    if (d && d.detail) {
      texto = d.detail;
    } else if (d && Object.keys(d).length) {
      texto = JSON.stringify(d);
    } else if (res.status >= 500) {
      texto = `${mensajeError} (error ${res.status} del servidor). ` +
              `Si el módulo se acaba de instalar, puede faltar aplicar las migraciones.`;
    } else if (res.status === 403) {
      texto = "Tu usuario no tiene acceso a este módulo.";
    } else if (res.status === 413) {
      // Lo corta el servidor web antes de llegar a Django, así que no viene
      // JSON: sin este caso el operador veía "error 413" a secas y no tenía
      // forma de saber que el problema era la foto.
      texto = "La foto pesa demasiado para el servidor. Tomala de nuevo, o guardá " +
              "la lectura sin foto y agregala después.";
    } else {
      texto = `${mensajeError} (error ${res.status}).`;
    }
    const err = new Error(texto);
    err.data   = d || {};
    err.status = res.status;
    throw err;
  }
  return res.json();
}

// ── Lecturas ──────────────────────────────────────────────────────────────────

export async function getLecturas(params = {}) {
  const limpio = Object.fromEntries(
    Object.entries(params).filter(([, v]) => v !== "" && v != null)
  );
  const qs = new URLSearchParams(limpio).toString();
  const res = await apiFetch(`${BASE}/${qs ? "?" + qs : ""}`);
  return leerJson(res, "Error al cargar las lecturas");
}

export async function crearLectura(formData) {
  const res = await apiFetch(`${BASE}/`, { method: "POST", body: formData });
  return leerJson(res, "Error al guardar la lectura");
}

export async function actualizarLectura(id, formData) {
  const res = await apiFetch(`${BASE}/${id}/`, { method: "PATCH", body: formData });
  return leerJson(res, "Error al actualizar la lectura");
}

export async function eliminarLectura(id) {
  const res = await apiFetch(`${BASE}/${id}/`, { method: "DELETE" });
  if (!res.ok) throw new Error("Error al eliminar la lectura");
}

// ── Filiales con su última lectura (selector de la pantalla de captura) ───────

export async function getFilialesAgua() {
  const res = await apiFetch(`${BASE}/filiales/`);
  return leerJson(res, "Error al cargar las filiales");
}

// ── Resumen y series ──────────────────────────────────────────────────────────

export async function getResumen(params = {}) {
  const limpio = Object.fromEntries(
    Object.entries(params).filter(([, v]) => v !== "" && v != null)
  );
  const qs = new URLSearchParams(limpio).toString();
  const res = await apiFetch(`${BASE}/resumen/${qs ? "?" + qs : ""}`);
  return leerJson(res, "Error al cargar el resumen");
}

export async function getSerie(params = {}) {
  const limpio = Object.fromEntries(
    Object.entries(params).filter(([, v]) => v !== "" && v != null)
  );
  const qs = new URLSearchParams(limpio).toString();
  const res = await apiFetch(`${BASE}/serie/${qs ? "?" + qs : ""}`);
  return leerJson(res, "Error al cargar la serie");
}

// ── Exportar ──────────────────────────────────────────────────────────────────

export async function exportarExcel(params = {}) {
  const limpio = Object.fromEntries(
    Object.entries(params).filter(([, v]) => v !== "" && v != null)
  );
  const qs = new URLSearchParams(limpio).toString();
  const res = await apiFetch(`${BASE}/exportar-excel/${qs ? "?" + qs : ""}`);
  if (!res.ok) throw new Error("Error al generar el Excel");
  const blob = await res.blob();
  const url  = URL.createObjectURL(blob);
  const a    = document.createElement("a");
  a.href     = url;
  a.download = "lecturas_agua.xlsx";
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
